import { useMemo } from "react";

import { useQuery } from "@apollo/client";
import { FieldType } from "@regal-voice/shared-types";

import { getEventFields, type EventSchemaListReturnType } from "ServerData/EventSchema/queries";

import type { EventSchemaOptionEntry } from "ServerData/EventSchema/eventSchemaTypes";

export function getEventTypeKey(conditionalType: string): string {
    return conditionalType === "regalVoiceEvent" ? "regal_voice_event" : "track";
}

const getEventFieldQueryVariables = (eventName: string, conditionalType: string) => {
    let eventTypeVariable = conditionalType;
    eventTypeVariable = getEventTypeKey(eventTypeVariable);
    const queryVar = { eventName, eventType: eventTypeVariable };
    return queryVar;
};

export function useEventPropertiesQuery(
    conditionalType: string,
    eventName: string
): { loading: boolean; eventSchema: EventSchemaOptionEntry } {
    const variables = getEventFieldQueryVariables(eventName, conditionalType);

    const { data, loading } = useQuery<EventSchemaListReturnType>(getEventFields, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache",
        variables,
    });
    const eventSchema = useMemo(() => {
        const outputObject = {} as EventSchemaOptionEntry;

        data?.getEventSchema.forEach((item) => {
            const fieldName = item.fieldName;
            outputObject[fieldName] = {
                fieldType: item.fieldType as FieldType,
                fieldId: item.fieldId,
            };
        });

        return outputObject;
    }, [data]);

    return { loading, eventSchema };
}
